import React, { lazy, Suspense, useEffect, useState } from 'react';
import { seismicTheme, Theme } from '@seismic/mantle';
import { getSeismicAuthToken } from 'utils/centralAuthToken';
import supportsLocalStorage from 'utils/supportsLocalStorage';
import { getService, TenantService } from '@seismic/browser-services';
import tenantEvents from 'utils/tenantEvents';

const TenantInfoCheck = new Promise(resolve => {
  //If the tenant info was initialized before this module was loaded
  if (supportsLocalStorage) {
    const tenantInfo = JSON.parse(localStorage.getItem('seismicTenantInfo'));
    if (tenantInfo) {
      resolve(tenantInfo);
    }
  }

  //If this module is loaded before the tenant info is initialized
  tenantEvents.on('tenantServiceInitd', tenantInfo => {
    resolve(tenantInfo);
  });
});

const AsyncUAR = lazy(() =>
  TenantInfoCheck.then(tenantInfo => {
    getService(TenantService).initTenantInfoByCache(tenantInfo);
    return import(
      /* webpackChunkName: "UAR" */ '@seismic/universal-audio-recorder'
    )
      .then(module => ({ default: module.UniversalAudioRecorder }))
      .catch(console.error);
  }).catch(console.error),
);

const UARecorder = props => {
  const { isOpen, onCancel, onUARReady, bssUploadOptions, handleComplete } =
    props;
  const [seismicAuthToken, setSeismicAuthToken] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    TenantInfoCheck.then(async tenantInfo => {
      getService(TenantService).initTenantInfoByCache(tenantInfo);
      const token = await getSeismicAuthToken();
      setSeismicAuthToken(token);
      setLoading(false);
    });
  }, []);
  useEffect(() => {
    if (!loading) {
      if (typeof onUARReady === 'function') {
        onUARReady();
      }
    }
  }, [onUARReady, loading]);

  return (
    <Theme theme={seismicTheme({ useGlobal: true })}>
      {!loading && (
        <Suspense fallback={null}>
          <AsyncUAR
            open={isOpen}
            onCancel={onCancel}
            getAuthToken={() => seismicAuthToken}
            bssUploadOptions={bssUploadOptions}
            onComplete={handleComplete}
          />
        </Suspense>
      )}
    </Theme>
  );
};

export default UARecorder;
